import { FC } from 'react';
import {
  SeparatorProps as ReactAriaSeparatorProps,
  useSeparator,
} from 'react-aria';
import { Colors } from 'src/styles';

type SeparatorProps = {
  error?: boolean;
  disabled?: boolean;
} & ReactAriaSeparatorProps;

export const Separator: FC<SeparatorProps> = (props) => {
  const { separatorProps } = useSeparator(props);

  return (
    <div
      style={{
        background: props.disabled
          ? `${Colors.inactive}`
          : props.error
          ? `${Colors.error}`
          : `${Colors.brand}`,
        width: '1px',
        height: '130%',
      }}
      {...separatorProps}
    />
  );
};
